import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'
import { formatadores } from 'src/paginas/aluno/painel-financeiro/pagina-financeiro/formatadores'

export const colunaDataOpcaoTCC = (): TabelaColuna => ({
  Chave: 'dataOpcaoTCC',
  ComOrdenacao: true,
  Renderizar: (linha: TabelaDados) => (
    <span>{formatadores.dataLocaleString(linha.dataOpcaoTCC)}</span>
  ),
  RenderizarCabecalho: () => <div style={{ width: 90 }}>Data Opção TCC</div>
})
